import React, { useState } from "react";

const ViewStrength = ({ stepData }: any) => {

    return (
        <>
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Strength</h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Joint Name</th>
                                            <th>Observation</th>
                                            <th>Strength</th>
                                            <th>Grade</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stepData.strength.map((row: any, index: number) => (
                                            <tr key={index}>
                                                <td>{row.joint_name}</td>
                                                <td>{row.observation}</td>
                                                <td>{row.strength}</td>
                                                <td>{row.grade}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default ViewStrength;